/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="user.service.ts" />
/// <reference path="../file/file.service.ts" />

module Eseebase {
    export class ProfileController implements angular.IController {
        public pictureUrl: string;
        public roles: string[];
        public repeatPassword: string
        public user: UserModel;
        public companies: OrganizationalUnitViewModel[];
        public uniqueCompanies: OrganizationalUnitViewModel[];

        $onInit = () => { };

        constructor(private $scope: ng.IScope,
            private userService: UserService,
            private organizationService: OrganizationService,
            private $q: ng.IQService,
            private $mdToast: any,
            private textService: TextService,
            private $mdDialog: any
        ) {
            var vm = this;

            var promisses = [];
            var deffered = $q.defer();
            promisses.push(
            this.userService.getRoles().then((data: string[]) => {
                    vm.roles = data;
                    deffered.resolve();
                }, () => { }));

            promisses.push(
                this.organizationService.list().then((data: OrganizationalUnitViewModel[]) => {
                vm.companies = data;
                vm.uniqueCompanies = [];
                for (var i = 0; i < data.length; i++) {
                    if (vm.uniqueCompanies.filter(c => c.companyNumber == data[i].companyNumber).length == 0) {
                        vm.uniqueCompanies.push(data[i]);
                    }
                }
                deffered.resolve();
            }));

            $q.all(promisses).then(() => this.getUser());
        }

        public getUser() {
            var vm = this;
            return this.userService.getUser().then((user: UserModel) => {
                vm.user = new UserModel();
                vm.user.id = user.id;
                vm.user.email = user.email;
                vm.user.name = user.name;
                vm.user.password = user.password;
                vm.user.organizationalUnitIds = user.organizationalUnitIds;
                vm.user.readOnly = user.readOnly;
                vm.user.phone = user.phone;
                vm.user.isSubscribed = user.isSubscribed;
                vm.user.defaultLanguage = user.defaultLanguage;
                vm.user.type = user.type;
                vm.repeatPassword = user.password;
                if (this.roles != null) {
                    vm.user.roleSelection = this.roles.map(r => new Role(r, user.roles.indexOf(r) > -1));
                    vm.user.companyNumber = user.companies[0].companyNumber;
                    vm.user.companies = user.companies;
                    vm.user.roles = user.roles;
                    vm.setCompanySelected(this.companies);
                }
                vm.pictureUrl = '/user/' + user.email + '/picture?now=' + new Date();
            }, () => window.location.href = '/#!/login');
        }

        public isAngelSelected() {
            var angelRole = (this.user == null || this.user.roleSelection == null) ? null : this.user.roleSelection.filter((val) => val.name == 'Angel');
            if (angelRole == null || angelRole.length == 0) {
                return false;
            }
            return angelRole[0].selected;
        }

        public selectRole(role: string) {
            var idx = this.user.roles.indexOf(role);
            if (idx > -1) {
                this.user.roles.splice(idx, 1);
            }
            else {
                this.user.roles.push(role);
            }
        }

        public onUploadSuccess() {
            this.pictureUrl = '/user/' + this.user.email + '/picture';
        }

        public onuploaderror() {
            alert("An error occured");
        }

        public saveUser(user: UserModel) {
            if (this.roles != null) {
                user.roles = user.roleSelection.filter(r => r.selected).map(r => r.name);
                var newOrgUnits = [];
                this.getSelectedCompanies(this.companies, newOrgUnits);
                user.organizationalUnitIds = newOrgUnits;
            }
            var vm = this;
            this.userService.createOrUpdate(user).then(r => {
                vm.userService.updateUser(user);
                vm.$mdToast.show(
                    vm.$mdToast.simple()
                        .textContent('User data has been saved')
                        .position('bottom center')
                        .hideDelay(5000)
                );
            }, (reason) =>
            {
                vm.$mdToast.show(
                    vm.$mdToast.simple()
                        .textContent(vm.textService.translate(reason))
                        .position('bottom center')
                        .hideDelay(5000)
                );
            });
        }

        public changePassword($event: any, userId: string) {
            var vm = this;
            this.$mdDialog.show({
                controller: function () {
                    this.currentPassword = '';
                    this.newPassword = '';
                    this.errorMessage = '';
                    this.userId = userId;
                    this.userService = vm.userService;
                    this.$mdDialog = vm.$mdDialog;
                    this.changePassword = function () {
                        this.errorMessage = '';
                        var ctrl = this;
                        this.userService.changePassword(this.userId, this.currentPassword, this.newPassword)
                            .then(() => {
                                this.$mdDialog.hide();
                            },
                            (rejection) => {
                                switch (rejection.status) {
                                    case 404:
                                        ctrl.errorMessage = 'The user does not exist or has been deleted.';
                                        break;
                                    case 401:
                                        ctrl.errorMessage = 'The supplied password is incorrect.';
                                        break;
                                }
                            });
                    }
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/change-password.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            })
            .then(function () {
                vm.$mdToast.show(
                    vm.$mdToast.simple()
                        .textContent('Password is updated')
                        .position('bottom center')
                        .hideDelay(5000)
                );
            }, () => { });
        }

        private getSelectedCompanies(list: OrganizationalUnitViewModel[], result: string[]) {
            if (list == null) {
                return;
            }
            for (var i = 0; i < list.length; i++) {
                if (list[i].selected) {
                    result.push(list[i].id);
                }
                else {
                    this.getSelectedCompanies(list[i].children, result);
                }
            }
        }

        private setCompanySelected(list: OrganizationalUnitViewModel[]) {
            if (list == null) {
                return;
            }
            for (var i = 0; i < list.length; i++) {
                list[i].selected =
                    this.user.organizationalUnitIds.indexOf(list[i].id) > -1;
                if (list[i].children != null && list[i].children.length > 0) {
                    this.setCompanySelected(list[i].children);
                }
            }
        }
    }

    ProfileController.$inject = ['$scope', 'UserService', 'OrganizationService', '$q', '$mdToast', 'TextService', '$mdDialog'];

    angular
        .module('eseebase')
        .controller('ProfileController', ProfileController);
}

